module.exports = __webpack_public_path__ + "img/banner-1.0be105b2.jpg";